import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTOPTION,
  DELETE_PRODUCTOPTION,
  UPDATE_PRODUCTOPTION,
  ADD_NEW_PRODUCTOPTION,
} from "./actionType";

import {
  getProductOptionSuccess,
  getProductOptionFail,
  deleteProductOptionSuccess,
  deleteProductOptionFail,
  updateProductOptionSuccess,
  updateProductOptionFail,
  addProductOptionSuccess,
  addProductOptionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveProductOptionApi,
  getProductOptionApi,
  updateProductOptionApi,
  deleteProductOptionApi,
  addNewProductOptionApi
} from "../../helpers/backend_helper";

function* getProductOption({ payload: productOption }) {
  try {
    const response = yield call(getProductOptionApi, productOption);
    yield put(getProductOptionSuccess(GET_PRODUCTOPTION, response.data));
  } catch (error) {
    yield put(getProductOptionFail(GET_PRODUCTOPTION, error));
  }
}

function* onUpdateProductOption({ payload: productOption }) {
  try {
    if (productOption.setApprove) {
      const response = yield call(approveProductOptionApi, productOption);
      yield put(updateProductOptionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductOptionApi, productOption);
      yield put(updateProductOptionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductOptionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductOption({ payload: productOption }) {
  try {
    const response = yield call(deleteProductOptionApi, productOption);
    yield put(deleteProductOptionSuccess({ productOption, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductOptionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductOption({ payload: productOption }) {
  try {
    const response = yield call(addNewProductOptionApi, productOption);
    yield put(addProductOptionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductOptionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductOption() {
  yield takeEvery(GET_PRODUCTOPTION, getProductOption);
}

export function* watchUpdateProductOption() {
  yield takeEvery(UPDATE_PRODUCTOPTION, onUpdateProductOption);
}

export function* watchDeleteProductOption() {
  yield takeEvery(DELETE_PRODUCTOPTION, onDeleteProductOption);
}

export function* watchAddNewProductOption() {
  yield takeEvery(ADD_NEW_PRODUCTOPTION, onAddNewProductOption);
}

function* productOptionSaga() {
  yield all([
    fork(watchGetProductOption),
    fork(watchDeleteProductOption),
    fork(watchUpdateProductOption),
    fork(watchAddNewProductOption)
  ]);
}

export default productOptionSaga;
